export default __webpack_public_path__ + "static/media/offer-vertical-chocolate-lyte.cbd2509a.png";